import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { ICommunicationLog } from 'app/models/communication-log/communication-log';

@Injectable({providedIn: 'root'})

export class CommunicationLogService {
  private api: string = environment.privateApi + 'CommunicationLog/';

  private http = inject(HttpClient);

  public getCommunicationLogs(entityId: number, entityType: string): Observable<ICommunicationLog[]> {
    return this.http.get<ICommunicationLog[]>(this.api + 'GetCommunicationLogs/' + entityId + '/' + entityType);
  }

}
